import React from 'react';
import './screens.css';

const LoginScreen = ({ appId, onLogin, goToHome }) => {
  return (
    <div className="login-container">
      <div className="logo-container">
        <div className="logo-wrapper">
          <div className="logo-text">
            <div className="logo-icon">
              <div className="logo-icon-inner">☀️</div>
            </div>
            アプつく！
          </div>
        </div>
      </div>
      
      <h2 className="login-title">LINEログイン</h2>
      
      <div className="login-box">
        <p className="login-message">
          {appId ? 'アプリの作成やいいね機能を使うには、LINEでログインしてください。アプリの閲覧のみであればログインは必要ありません。' : 'アプリの作成や管理をするには、LINEでログインしてください。'}
        </p>
        <button
          className="login-button"
          onClick={onLogin}
        >
          LINEでログインする
        </button>
        
        <p className="separator">
          または
        </p>
        
        <button
          className="skip-button"
          onClick={goToHome}
        >
          {appId ? 'ログインせずにアプリを見る' : 'ログインせずにホーム画面を見る'}
        </button>
      </div>
      
      <div className="info-text">
        <p>「アプつく！」は自分だけのアプリを簡単に作れるサービスです。</p>
        <p>LINEでログインすると、アプリの作成やいいね機能が使えます。</p>
        <p>アプリの閲覧のみであれば、ログインは必要ありません。</p>
      </div>
    </div>
  );
};

export default LoginScreen;